import { RootState, SetState } from '@/store/useStore.ts';
import {
  AmplitudeExperimentsPayload,
  CustomerDataErrorPayload,
  CustomerDataPayload,
  CustomerDataSlice,
  CustomerPreferencesPayload,
  CustomerStoreParts,
} from '@/store/slices/customerData/types';
import { emptySliceError } from '../sliceError';

const defaultCustomerDataContext = {
  loading: true,
  packageLoading: false,
  data: null,
  features: [],
  segment: null,
};

const defaultPreferencesContext = {
  showTCPopupCounter: 0,
  showTCPopup: false,
  showDYBPopupCounter: 0,
  showDYBPopup: false,
  showDYBTutorialCounter: 0,
  showDYBTutorial: false,
};

const defaults = {
  customerData: defaultCustomerDataContext,
  customerPreferences: defaultPreferencesContext,
  amplitudeExperiments: {},
  customerDataError: emptySliceError(),
};

export const customerDataSlice = ({
  set,
}: SetState<RootState>): CustomerDataSlice => ({
  customerData: { ...defaults.customerData },
  customerPreferences: { ...defaults.customerPreferences },
  amplitudeExperiments: { ...defaults.amplitudeExperiments },
  customerDataError: { ...defaults.customerDataError },

  setCustomerData: (newState: CustomerDataPayload) =>
    set(
      (state: RootState) => ({
        ...state,
        customerData: { ...state.customerData, ...newState },
      }),
      false,
      'customerData/setCustomerData',
    ),

  setCustomerPreferences: (newState: CustomerPreferencesPayload) =>
    set(
      (state: RootState) => ({
        ...state,
        customerPreferences: { ...state.customerPreferences, ...newState },
      }),
      false,
      'customerData/setCustomerPreferences',
    ),

  setAmplitudeExperiments: (newState: AmplitudeExperimentsPayload) =>
    set(
      (state: RootState) => ({
        ...state,
        amplitudeExperiments: { ...state.amplitudeExperiments, ...newState },
      }),
      false,
      'customerData/setAmplitudeExperiments',
    ),

  setCustomerDataError: (newState: CustomerDataErrorPayload) =>
    set(
      (state: RootState) => ({
        ...state,
        customerDataError: {
          ...state.customerDataError,
          ...newState,
        },
      }),
      false,
      'customerData/setCustomerDataError',
    ),

  resetCustomerStorePart: (part: CustomerStoreParts) =>
    set(
      (state) => ({
        ...state,
        [part]: { ...defaults[part] },
      }),
      false,
      `customerData/reset/${part}`,
    ),

  resetAllCustomerParts: () =>
    set(
      () => ({
        customerData: { ...defaults.customerData },
        customerPreferences: { ...defaults.customerPreferences },
        amplitudeExperiments: { ...defaults.amplitudeExperiments },
        customerDataError: { ...defaults.customerDataError },
      }),
      false,
      'customerData/resetCustomerData',
    ),
});
